:host {
  /**
   * @prop --c-toolbar-background-color: Toolbar background color
   * @prop --c-toolbar-text-color: Toolbar text color
   */
  --_c-toolbar-background-color: var(--c-toolbar-background-color, var(--c-white));
  --_c-toolbar-text-color: var(--c-toolbar-text-color, var(--c-text-system));

  z-index: 1;

  .c-toolbar {
    align-items: center;
    background: var(--_c-toolbar-background-color);
    box-shadow: 2px 4px 10px #00000029;
    color: var(--_c-toolbar-text-color);
    column-gap: 12px;
    display: flex;
    height: 60px;
    padding-left: 16px;
    padding-right: 16px;
    position: fixed;
    width: 100%;
  }

  .spacer {
    height: 60px;
    width: 100%;
  }
}

:host(.relative) .c-toolbar {
  position: relative;
  margin-bottom: -60px;
}
